import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useInquiry } from "@/context/InquiryContext";

export default function FloatingQuote() {
  const { openQuote } = useInquiry();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <motion.button
      data-testid="floating-get-quote-btn"
      onClick={() => openQuote()}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.6 }}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-safety px-5 py-3.5 text-sm font-semibold text-white shadow-xl shadow-sky-900/25 transition hover:bg-safety-dark hover:shadow-2xl print:hidden"
    >
      <MessageCircle size={18} />
      <span className="hidden sm:inline">Ask for Price</span>
    </motion.button>
  );
}
